<template>
  <v-dialog
    :value="value"
    :fullscreen="isFullscreen"
    :width="isFullscreen ? null : 1000"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card class="d-flex flex-column" :tile="isFullscreen">
      <v-toolbar class="flex-grow-0">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items class="ml-3">
          <v-btn
            icon
            tile
            @click="isContainSize = !isContainSize"
          >
            <v-icon>
              {{ isContainSize ? 'photo_size_select_large' : 'photo_size_select_actual' }}
            </v-icon>
          </v-btn>
          <v-btn
            icon
            tile
            @click="isFullscreen = !isFullscreen"
          >
            <v-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
          </v-btn>
          <v-btn
            icon
            tile
            @click="$emit('input', false)"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text class="d-flex justify-center align-center pa-1">
        <v-img
          :contain="isContainSize"
          :aspect-ratio="isContainSize ? null : 1"
          :src="src"
          width="100%"
          height="100%"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PreviewImageDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isContainSize: true,
      isFullscreen: false,
    };
  },
};
</script>
